// Copyright (c) 2016 Deere & Company

import Modal, {getDefaultState as getModalDefaultState} from '../../shared/state/modal';

const NewTransferStatusChangeModal = Modal;

export const getDefaultState = () => getModalDefaultState();

export default NewTransferStatusChangeModal;



// WEBPACK FOOTER //
// ./src/product/new-transfer/state/new-transfer-status-change-modal.js